const firebaseConfig = {
  apiKey: "AIzaSyDe7hT9iYw4GnnxL5NCqC_5yCN89oGTbUA",
  authDomain: "eye-care-cent.firebaseapp.com",
  projectId: "eye-care-cent",
  storageBucket: "eye-care-cent.appspot.com",
  messagingSenderId: "490190066446",
  appId: "1:490190066446:web:28ee8bcc8b2f61a82dbd5f",
};

export default firebaseConfig;
